import { LIST } from './action-types';

export function list(payload: any) {
    return {
        type: LIST,
        payload,
    };
}
